import React, { useState } from 'react';
import './DonationRequestFormModal.css'; 

const DonationRequestFormModal = ({ onClose }) => {
  const [formData, setFormData] = useState({
    hospital_name: '',
    medicine: '',
    quantity_needed: '',
    reason: '',
    location: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    console.log('Donation Request Submitted:', formData);
    onClose(); 
  };

  return (
    <div className="request-form-modal-overlay">
      <div className="request-form-modal-content">
        <h2>Request Medicine Donation</h2>
        <form onSubmit={handleFormSubmit}>
          <div className="form-group">
            <label>Hospital Name</label>
            <input
              type="text"
              name="hospital_name"
              value={formData.hospital_name}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Medicine Name</label>
            <input
              type="text"
              name="medicine"
              value={formData.medicine}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Quantity Needed</label>
            <input
              type="text"
              name="quantity_needed"
              value={formData.quantity_needed}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Location</label>
            <input
              type="text"
              name="location"
              value={formData.location}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Reason</label>
            <textarea
              name="reason"
              value={formData.reason}
              onChange={handleInputChange}
              required
            ></textarea>
          </div>
          <button type="submit" className="submit-btn">Request Now</button>
        </form>
        <button onClick={onClose} className="close-btn">Close</button>
      </div>
    </div>
  );
};

export default DonationRequestFormModal;
